/* Adi&May-Videos auf der Website. Entwurf 16.09.2026.
   - laedt erst, wenn das Video in Sichtweite kommt (preload="none" + IntersectionObserver)
   - waehlt hoch/quer nach Bildschirmbreite, das media-Attribut an <source> tun Browser nicht
   - stumm mit Untertiteln, ein Knopf schaltet den Ton dazu
   - bei „Bewegung reduzieren" laeuft nichts von allein, es bleibt das Standbild  */
(function () {
  var schmal = window.matchMedia('(max-width: 767px)');
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');

  function quelle(el) {
    var q = schmal.matches ? el.dataset.hoch : el.dataset.quer;
    return q || el.dataset.quer || el.dataset.hoch;
  }

  function bauen(box) {
    if (box.dataset.fertig) return;
    box.dataset.fertig = '1';
    var v = document.createElement('video');
    v.className = 'mp-video__film';
    v.muted = true;
    v.loop = box.dataset.schleife !== 'nein';
    v.playsInline = true;
    v.preload = 'none';
    v.setAttribute('playsinline', '');
    v.poster = box.dataset.bild || '';
    if (box.dataset.titel) v.setAttribute('aria-label', box.dataset.titel);


    var ton = document.createElement('button');
    ton.type = 'button';
    ton.className = 'mp-video__ton';
    ton.innerHTML = symbol(false) + '<span>Ton an</span>';
    ton.addEventListener('click', function () {
      v.muted = !v.muted;
      ton.innerHTML = symbol(!v.muted) + '<span>' + (v.muted ? 'Ton an' : 'Ton aus') + '</span>';
      if (!v.muted) v.play().catch(function () {});
    });

    var dauer = document.createElement('span');
    dauer.className = 'mp-video__dauer';
    dauer.textContent = box.dataset.dauer || '';

    box.appendChild(v);
    box.appendChild(dauer);
    if (!ruhig.matches) box.appendChild(ton);

    v.src = quelle(box);
    v.addEventListener('loadeddata', function () { box.classList.add('ist-da'); }, { once: true });
    /* ⚠ play() direkt nach dem Setzen von src scheitert bei preload="none", das Element ist
       noch nicht so weit. Erst auf canplay starten, sonst bleibt das Video stumm stehen. */
    if (!ruhig.matches) {
      v.addEventListener('canplay', function () {
        v.play().catch(function () { knopfZeigen(box, v); });
      }, { once: true });
      v.load();
    } else {
      knopfZeigen(box, v);
    }

    /* Untertitel zeichnen wir selbst.
       ⚠ Die eingebaute Darstellung (::cue) laesst sich kaum gestalten, Safari und Chrome
       setzen sie unterschiedlich, und in Screenshots taucht sie gar nicht auf. Die Spur
       laeuft deshalb auf "hidden": der Browser laedt und taktet die Cues, malt sie aber
       nicht, und wir setzen den Text in ein eigenes Feld in unserer Schrift. */
    var feld = document.createElement('div');
    feld.className = 'mp-video__ut';
    feld.setAttribute('aria-live', 'polite');
    box.appendChild(feld);

    /* ⚠ 16.09.2026: Ein <track src="..."> funktioniert hier NICHT. Shopify liefert
       Dateien, die nicht als Video-Typ hochgeladen wurden, mit dem Inhaltstyp
       application/octet-stream aus, und der Browser weigert sich dann, die Spur zu
       lesen (null Cues, keine Fehlermeldung). Wir holen die Datei deshalb selbst
       (CORS ist offen) und bauen die Spur im Browser zusammen. */
    if (box.dataset.vtt) spurLaden(box.dataset.vtt, v, feld);
  }

  /* WebVTT einlesen: Bloecke sind durch Leerzeilen getrennt, die Zeitzeile enthaelt "-->" */
  function vttLesen(text) {
    var raus = [];
    text.replace(/\r/g, '').split(/\n\n+/).forEach(function (block) {
      var zeilen = block.split('\n').filter(function (z) { return z.trim(); });
      if (!zeilen.length || /^WEBVTT/.test(zeilen[0])) return;
      var i = zeilen[0].indexOf('-->') >= 0 ? 0 : 1;   // erste Zeile kann eine Nummer sein
      if (!zeilen[i] || zeilen[i].indexOf('-->') < 0) return;
      var teile = zeilen[i].split('-->');
      var txt = zeilen.slice(i + 1).join(' ').replace(/<[^>]+>/g, '').trim();
      if (!txt) return;
      raus.push({ von: sekunden(teile[0]), bis: sekunden(teile[1]), text: txt });
    });
    return raus;
  }
  function sekunden(s) {
    var t = s.trim().split(' ')[0].split(':').map(parseFloat);
    return t.length === 3 ? t[0] * 3600 + t[1] * 60 + t[2] : t[0] * 60 + t[1];
  }
  function spurLaden(url, v, feld) {
    fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      var cues = vttLesen(t);
      if (!cues.length) return;
      var spur = null;
      try {
        spur = v.addTextTrack('subtitles', 'Deutsch', 'de');
        spur.mode = 'hidden';
        cues.forEach(function (c) { spur.addCue(new VTTCue(c.von, c.bis, c.text)); });
        spur.addEventListener('cuechange', function () {
          var a = spur.activeCues && spur.activeCues.length ? spur.activeCues[0] : null;
          feld.textContent = a ? a.text : '';
          feld.classList.toggle('ist-da', !!a);
        });
      } catch (e) { spur = null; }
      /* Rueckfall, falls VTTCue fehlt: selbst takten */
      if (!spur) {
        v.addEventListener('timeupdate', function () {
          var z = v.currentTime, a = null;
          for (var i = 0; i < cues.length; i++) if (z >= cues[i].von && z <= cues[i].bis) { a = cues[i]; break; }
          feld.textContent = a ? a.text : '';
          feld.classList.toggle('ist-da', !!a);
        });
      }
    }).catch(function () {});
  }

  /* Wenn der Browser das Starten verweigert (oder „Bewegung reduzieren" an ist):
     eigener Abspielknopf statt der Systemleiste, die neben unseren Knoepfen fremd wirkt. */
  function knopfZeigen(box, v) {
    if (box.querySelector('.mp-video__start')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mp-video__start';
    b.setAttribute('aria-label', 'Video abspielen');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5-11-6.5Z"/></svg>';
    b.addEventListener('click', function () {
      v.play().then(function () { b.remove(); }).catch(function () { v.controls = true; b.remove(); });
    });
    box.appendChild(b);
  }

  function symbol(an) {
    return an
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4V5Z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M19 5a9 9 0 0 1 0 14"/></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4V5Z"/><path d="m22 9-6 6"/><path d="m16 9 6 6"/></svg>';
  }

  var beobachter = new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) {
      var box = e.target;
      if (e.isIntersecting) {
        bauen(box);
        var v = box.querySelector('video');
        if (v && !ruhig.matches && v.paused && v.dataset.vomNutzerGestoppt !== '1') {
          v.play().then(function () { var s = box.querySelector('.mp-video__start'); if (s) s.remove(); })
                  .catch(function () {});
        }
      } else {
        var w = box.querySelector('video');
        if (w && !w.paused) w.pause();
      }
    });
  }, { threshold: 0.3 });

  /* Videos in den Antworten des Akkordeons.
     ⚠ Das Antwortfeld ist ein richtext-Feld: Shopify laesst darin nur <p>, Listen und
     Ueberschriften zu, kein <div> und keine Klassen. Der Push wird sonst abgewiesen.
     Die Zuordnung Frage -> Video kommt deshalb als JSON aus einer custom-liquid-Sektion,
     und das Videofeld wird hier eingehaengt. */
  function fragenVideos() {
    var quelle = document.getElementById('mp-video-fragen');
    if (!quelle || quelle.dataset.fertig) return;
    var liste; try { liste = JSON.parse(quelle.textContent); } catch (e) { return; }
    quelle.dataset.fertig = '1';
    var punkte = [].slice.call(document.querySelectorAll('.t4s-tab-wrapper'));
    liste.forEach(function (e) {
      var ziel = punkte.filter(function (w) {
        var t = w.querySelector('.t4s-accor-text');
        return t && t.textContent.replace(/\s+/g, ' ').trim() === e.frage;
      })[0];
      if (!ziel) return;
      var inhalt = ziel.querySelector('.t4s-tab-content');
      if (!inhalt || inhalt.querySelector('.mp-video')) return;
      var block = document.createElement('div');
      block.className = 'mp-video-block';
      var feld = document.createElement('div');
      feld.className = 'mp-video mp-video--antwort';
      feld.dataset.quer = e.quer; feld.dataset.hoch = e.hoch; feld.dataset.bild = e.bild;
      feld.dataset.vtt = e.vtt; feld.dataset.dauer = e.dauer; feld.dataset.titel = e.titel;
      var zeile = document.createElement('p');
      zeile.className = 'mp-video-block__zeile';
      zeile.innerHTML = e.zeile;
      block.appendChild(feld); block.appendChild(zeile);
      inhalt.appendChild(block);
      beobachter.observe(feld);
    });
  }

  function start() {
    fragenVideos();
    document.querySelectorAll('.mp-video').forEach(function (b) { beobachter.observe(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* Im Akkordeon: erst bauen, wenn die Antwort offen ist */
  document.addEventListener('click', function (e) {
    var kopf = e.target.closest('[data-akkordeon], [data-t4s-tab-item]');
    if (!kopf) return;
    var feld = kopf.parentElement.querySelector('.mp-video') ||
               (kopf.closest('.t4s-tab-wrapper') || kopf.parentElement).querySelector('.mp-video');
    if (feld) setTimeout(function () { bauen(feld); }, 60);
  });
})();
